// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"fe321d63","592":"fb286be6"}[chunkId] + ".chunk.css";
};